import { lazy, useEffect, useState } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { useParams } from "react-router";
import { LoadingSpinner } from "widgets";

import type { IGenomeState } from "@/redux/modules/genome.ts";
import type { IAppState } from "@/redux/reducer.ts";
import styleLayout from "@/ui-modules/core/styles/PageLayout.module.scss";

const GenomeViewerPage = lazy(() => import("@/modules/genome-viewer/GenomeViewerPage.tsx"));

export const GenomeSyntenyView = () => {
  const [isLoading, setLoading] = useState(true);
  const { genome } = useSelector<IAppState, IGenomeState>((state) => state.genome, shallowEqual);
  const { genomeId } = useParams<"genomeId">();

  useEffect(() => {
    setLoading(false);
  }, [genome]);

  if (isLoading) {
    return (
      <div className={styleLayout.page}>
        <LoadingSpinner inCenter />
      </div>
    );
  }

  return <GenomeViewerPage syntenyId={genomeId} />;
};
